import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import Modal from "react-bootstrap/Modal";
import "./modalMensajes.scss";
import { memo } from "react";
import React, { useEffect } from "react";
import Titulo from "../../../atoms/titles/Titulo";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "../../../../hooks/useLocalStorage";
import ButtonCard from "../../../atoms/buttons/ButtonCard";

registerLocale("es", es);

const ModalMensajes = (object) => {
  const [token] = useLocalStorage("token", "");
  
  
  useEffect(() => {}, [token]);
  let navigate = useNavigate();

  function modalMensajes() {
    return (
      <Modal
        className="infModal fechas z-index-1055"
        show={object.show}
        onHide={object.handleClose}
        backdrop="static"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {/* <Titulo titulo={"Aviso"} tipo={"tituloModal"} /> */}
            <h4 className="tituloModal">Aviso</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="caja_formulario col-xxl-12 col-xl-12 col-lg-12 cold-md-12 cold-sm-12">
            {object.titulo ? (
              <Titulo
                titulo={object.titulo}
                tipo={`text-center ${object.tipo}`}
              />
            ) : null}
            {object.texto ? <p>{object.texto}</p> : null}
            {object.texto2 ? <p>{object.texto2}</p> : null}
            {object.content ? (
              <>
                <p className={`fs-7 ${object?.contentClass}`}>
                  {object.content}{" "}
                </p>
                <span className="fw-bold fs-5">{object.contentBold2}</span>{" "}
                <p className={`fs-7 ${object?.contentClass}`}>
                  {object.content2}{" "}
                </p>
              </>
            ) : null}
            {object.otherContent ? <h5>{object.otherContent}</h5> : null}
          </div>
          {}
          {!object.aviso ? (
            <>
              {" "}
              <ButtonCard
                id="btnCerrar"
                clases="btn-card mt-2"
                nombre={
                  object?.boton === null || object?.boton === undefined
                    ? "Cerrar"
                    : object.boton
                }
                funcion={() => {
                  if (
                    object.valorFuncion !== undefined &&
                    object.valorFuncion !== null
                  ) {
                    object.funcion(object.valorFuncion);
                  }
                  if (object.boton === "Aceptar") {
                    object.handleResolucion(object.contentBold);
                  }
                  if (object.destinoCerrar !== null) {
                    navigate(`${object.destinoCerrar}`, {
                      state: object.stateParams,
                    });
                  }
                  object.handleClose();
                }}
              />
            </>
          ) : (
            <>
              <ButtonCard
                id="btnAceptar"
                clases="btn-card mt-2 rounded"
                nombre={"Aceptar"}
                funcion={() => {
                  if (
                    object.valorFuncion !== undefined &&
                    object.valorFuncion !== null
                  ) {
                    object.funcion(object.valorFuncion);
                  }
                  if (
                    object.valorFuncion2 !== undefined &&
                    object.valorFuncion2 !== null
                  ) {
                    object.funcion2(object.valorFuncion2);
                  }
                  if (object.destinoAviso !== null) {
                    
                    
                    navigate(`${object.destinoAviso}`,  {state:object.destinoState});
                  }
                  object.handleClose();
                }}
              />
              <ButtonCard
                id="btnDenegar"
                clases="btn-card bg-danger mt-2 rounded"
                nombre={"Denegar"}
                funcion={() => {
                  object.handleClose();
                }}
              />
            </>
          )}
        </Modal.Body>
      </Modal>
    );
  }

  return <>{modalMensajes()}</>;
};

export default memo(ModalMensajes);
